import React from 'react';

interface Props {
  isOpen: boolean;
  children: React.ReactNode;
}

export default function AccordionHeader(props: Props) {
  return (
    <div aria-expanded={props.isOpen} role="button">
      {props.children}
    </div>
  );
}
